// extracted by mini-css-extract-plugin
module.exports = {"borderedImg":"IntroPhoto-module--borderedImg--UlXSV","imgWithBorder":"IntroPhoto-module--imgWithBorder--3ZQ3B"};